/** Genuinely-empty state: icon + message + optional call to action. */
import { Button, Stack, Typography, type SxProps } from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";
import type { ReactNode } from "react";

export function EmptyState({
  icon,
  message,
  actionLabel,
  onAction,
  sx,
}: {
  icon?: ReactNode;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  sx?: SxProps;
}) {
  return (
    <Stack
      alignItems="center"
      spacing={1}
      sx={{ py: 4, color: "text.disabled", textAlign: "center", ...((sx as object) ?? {}) }}
    >
      {icon ?? <InboxIcon fontSize="large" />}
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
      {actionLabel && onAction && (
        <Button size="small" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Stack>
  );
}
